var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",style:(_vm.avatarStyle),on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.name[0])+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }